export default {
  dobsovic: {
    fullName: 'Ľudovít Dobšovič',
    picture: require('../resources/dobsovic.jpg'),
  },
  hambalek: {
    fullName: 'Vladimír Hambálek',
    picture: require('../resources/hambalek.jpg'),
  },
  juras: {
    fullName: 'Ivan Juráš',
    picture: require('../resources/juras.jpg'),
  },
  lutherova: {
    fullName: 'Viera Lutherová',
    picture: require('../resources/lutherova.jpg'),
  },
  slimakova: {
    fullName: 'Margit Slimáková',
    picture: require('../resources/slimakova.jpg'),
  },
  svoboda: {
    fullName: 'Jan Svoboda',
    picture: require('../resources/svoboda.jpg'),
  },
  stransky: {
    fullName: 'Martin Jan Stránský',
    picture: require('../resources/stransky.jpg'),
  },
  trckova: {
    fullName: 'Jana Trčková',
    picture: require('../resources/trckova.jpg'),
  },
  jakubco: {
    fullName: 'Alexander Jakubčo',
    picture: require('../resources/jakubco.jpg'),
  },
  popovicova_and_kuzmova: {
    fullName: 'Alexandra Popovičová a Silvia Kuzmová',
    picture: require('../resources/popovicova_and_kuzmova.jpg'),
  },
  encounter: {
    fullName: 'Dvě skupiny - Sál 1 a Sál 2',
    picture: require('../resources/encounters.jpg'),
  },
  panelova_diskusia: {
    fullName: '',
    picture: require('../resources/panelova_diskusia.jpg'),
  },
  workshops: {
    metaOnly: true,
    fullName: 'Místnosti na prvním patre',
    picture: require('../resources/workshops.jpg'),
  },
  kuchapecha: {
    metaOnly: true,
    fullName: '',
    picture: require('../resources/kuchapecha.jpg'),
  },
  none: {
    fullName: '',
    picture: require('../resources/default_session-min.png'),
    metaOnly: true,
  },
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presenters.js